import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form, Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import logo from '../../../assets/images/bombiix-logo.svg';
import './Verificationcode.css';
import { verifyCode, recoverRequestSent } from '../store/Auth.action';

function VerificationCode() {
  const [code, setCode] = useState('');
  const [loader, setLoader] = useState(false);
  const [emailId, setEmailId] = useState('');
  const [remember, setRemember] = useState(false);
  const [mfaType, setMfaType] = useState('');

  const productRights = true;
  const dispatch = useDispatch();
  const history = useHistory();
  // Define a state for error messages
  const [errors, setErrors] = useState({
    code: '',
    password: '',
  });
  const { t } = useTranslation('common');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (user) {
      setEmailId(user?.email);
      const formattedMfaType = user?.mfaType.replace(/[^a-zA-Z ]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
      setMfaType(formattedMfaType);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Reset error messages
    setErrors({ email: '', password: '', isError: false });
    let formError = false;

    if (!code) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        code: t('MULTIFACTOR_TYPE.CODE_REQUIRED'),
        isError: true,
      }));
      formError = true;
    }
    if (!formError) {
      const payload = {
        code,
        email: emailId,
        remember,
      };
      setLoader(true);
      const res = await dispatch(verifyCode(payload, t));

      if (res?.isVerified) {
        const userDetails = JSON.parse(localStorage.getItem('loggedInUserInfo'));
        const updatedDetails = { ...userDetails, mfaVerified: true };
        localStorage.setItem('loggedInUserInfo', JSON.stringify(updatedDetails));
        if (localStorage.getItem('redirectToPO')) {
          const supplierData = localStorage.getItem('redirectToPO');
          window.location.href = `${window.location.origin}${supplierData}`;
        } else if (localStorage.getItem('redirectionToPO')) {
          const poRedirect = localStorage.getItem('redirectionToPO');
          window.location.href = poRedirect;
        } else if (productRights) {
          window.location.href = `${window.location.origin}/todo-list/my-todo`;
        } else {
          window.location.href = `${window.location.origin}/todo-list/sample-requests`;
        }
      }
      setLoader(false);
    }
  };

  const handleInputChange = (keyName, value) => {
    setErrors(() => ({
      code: '',
      isError: false,
    }));
    setCode(value);
  };

  const handleCheckbox = (e) => {
    setRemember(e.target.checked);
  };

  const handleRecovery = async () => {
    await dispatch(recoverRequestSent({ email: emailId }, t));
  };
  const redirectToLoginPage = () => {
    history.push('/login');
  };

  return (
    <Container>
      <div className="login-container-bombiix">
        <div className="logo-container">
          <img src={logo} className="img-fluid logo-image" alt="logo" />
        </div>

        <div className="mt-40">
          {mfaType && (
            <span className="text-medium">
              {t('MULTIFACTOR_TYPE.MFA_AUTH')}: {mfaType}
            </span>
          )}
          <Form className="login-form mt-3" onSubmit={handleSubmit} autoComplete="off">
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="">
                {t('SIGNUP.VERIFICATION')}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                key="code"
                id="code"
                name="code"
                className={code && 'data-filled'}
                value={code}
                onChange={(e) => handleInputChange('email', e.target.value)}
                autoComplete="new-email"
              />

              {errors?.isError && <div className="text-danger err-text">{errors?.code}</div>}
            </Form.Group>

            <div className="mt-2">
              <Form.Group className="ms-auto" controlId="formBasic">
                <Form.Check
                  type="checkbox"
                  name="remember"
                  className="custom-checkbox-signed pl-0 cursor-pointer"
                  label={t('MULTIFACTOR_TYPE.REMEMBER_THIS_DEVICE')}
                  checked={remember}
                  onChange={handleCheckbox}
                />
              </Form.Group>
              <p onClick={handleRecovery} className="text-medium recovery-link">
                {t('SIGNUP.HAVING_TROBLE_VERIFY_CODE')} <span className="text-click text-bold">{t('SIGNUP.CLICK')}</span>
              </p>
              <div className="d-flex">
                <Button onClick={redirectToLoginPage} variant="primary" className="btn-white" type="button">
                  {t('SIGNUP.BACK')}
                </Button>
                <Button disabled={loader} variant="primary" className="btn-theme ml-16" type="submit">
                  {t('SETUP_2FA.SUBMIT')}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
}

export default VerificationCode;
